import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';


export const  AlertDialog = (props:any) => {
  

  return (
    <React.Fragment>
      <Dialog
        open={props.isOpen}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span><WarningIcon/> </span>{props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{textTransform:"none"}} onClick={props.handleClose}>Disagree</Button>
          <Button sx={{textTransform:"none"}} onClick={props.onConfirm}>Agree</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}